import { IReportRow, IReportsParams } from '../../../types/reports';
import { IPickerOption } from 'src/view/components/Controls/Pickers/Picker/types/index';

export interface ILocationReports {
  branches: {
    data?: IReportRow[];
    loading: boolean;
  };
  areas: {
    data?: IReportRow[];
    loading: boolean;
  };
}

export interface ILocationReportFilters {
  branches: IPickerOption[];
  areas: IPickerOption[];
  branchesStatus: IPickerOption;
}

export interface IBranchesReportParams extends IReportsParams {
  branches: number[];
  branch_status: BRANCHES_STATUS;
}

export interface IAreasReportParams extends IReportsParams {
  areas: number[];
}

export enum BRANCHES_STATUS {
  All = 'all',
  ACTIVE = 'active',
  DELETED = 'deleted',
  DISABLED = 'disabled',
}
